import * as swcHelpers from '@swc/helpers';
import { fromAppointmentTypeQueryToAppointmentType } from '../adapters/from-appointment-type-query-to-appointment-type.js';
import { GET_BOOK_APPOINTMENT_TYPE } from '../queries/get-book-appointment-type.js';

const getBookAppointmentType = function() {
    var _ref = swcHelpers.asyncToGenerator(function*(apolloClient, id, locale) {
        if (id === undefined) {
            return null;
        }
        try {
            const { data , error  } = yield apolloClient.query(swcHelpers.objectSpread({
                query: GET_BOOK_APPOINTMENT_TYPE,
                variables: {
                    id
                }
            }, locale ? {
                context: {
                    forwardHeaders: {
                        'Accept-Language': locale
                    }
                }
            } : {}));
            const appointmentTypeQueryData = data === null || data === void 0 ? void 0 : data.appointmentType;
            const appointmentTypeData = fromAppointmentTypeQueryToAppointmentType(appointmentTypeQueryData);
            if (error) {
                console.error(error);
            }
            return appointmentTypeData;
        } catch (error) {
            console.error(error);
            return null;
        }
    });
    return function getBookAppointmentType(apolloClient, id, locale) {
        return _ref.apply(this, arguments);
    };
}();

export { getBookAppointmentType };
//# sourceMappingURL=book-appointment-type.js.map
